import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createJob } from "../../features/jobs/jobsSlice";

export default function Form() {
  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [salary, setSalary] = useState("");
  const [deadline, setDeadline] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const reset = () => {
    setTitle("");
    setType("");
    setSalary("");
    setDeadline("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(
      createJob({
        title,
        type,
        salary: Number(salary),
        deadline: deadline,
      })
    );
    reset();
    navigate("/");
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div className="fieldContainer">
        <label
          htmlFor="lwsJobTitle"
          className="text-sm font-medium text-slate-300"
        >
          Job Title
        </label>
        <select
          id="lwsJobTitle"
          name="lwsJobTitle"
          autoComplete="lwsJobTitle"
          required
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        >
          <option defaultValue hidden>
            Select Job
          </option>
          <option>Software Engineer</option>
          <option>Software Developer</option>
          <option>Full Stack Developer</option>
          <option>MERN Stack Developer</option>
          <option>DevOps Engineer</option>
          <option>QA Engineer</option>
          <option>Product Manager</option>
          <option>Social Media Manager</option>
          <option>Senior Executive</option>
          <option>Junior Executive</option>
          <option>Android App Developer</option>
          <option>IOS App Developer</option>
          <option>Frontend Developer</option>
          <option>Frontend Engineer</option>
        </select>
      </div>
      <div className="fieldContainer">
        <label htmlFor="lwsJobType">Job Type</label>
        <select
          id="lwsJobType"
          name="lwsJobType"
          autoComplete="lwsJobType"
          required
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option defaultValue hidden>
            Select Job Type
          </option>
          <option>Full Time</option>
          <option>Internship</option>
          <option>Remote</option>
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lwsJobSalary">Salary</label>
        <div className="flex border rounded-md shadow-sm border-slate-600">
          <span className="input-tag">BDT</span>
          <input
            type="number"
            name="lwsJobSalary"
            id="lwsJobSalary"
            required
            className="!rounded-l-none !border-0"
            placeholder="20,00,000"
            value={salary}
            onChange={(e) => setSalary(e.target.value)}
          />
        </div>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lwsJobDeadline">Deadline</label>
        <input
          type="date"
          name="lwsJobDeadline"
          id="lwsJobDeadline"
          required
          value={deadline}
          onChange={(e) => setDeadline(e.target.value)}
        />
      </div>
      <div className="text-right">
        <input
          type="submit"
          value="Save"
          className="lws-submit cursor-pointer btn btn-primary w-fit"
        />
      </div>
    </form>
  );
}
